"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// This function takes the locale object and converts it into a structure required by date-fns's distanceInWords function
var buildLocale = function buildLocale(_ref) {
  var locale = _ref.locale;

  // eslint-disable-next-line arrow-body-style
  var getResult = function getResult(token, count) {
    return typeof locale[token] === 'string' ? locale[token] : count === 1 && locale[token] && locale[token].one || locale[token] && locale[token].other.replace('{{count}}', count);
  };
  var localize = function localize(token, count, options) {
    var optionsApplied = options || {};
    var result = getResult(token, count);
    return optionsApplied.addSuffix && (optionsApplied.comparison > 0 ? "".concat(locale.in, " ").concat(result) : "".concat(result, " ").concat(locale.ago)) || result;
  }; // eslint-disable-next-line sonarjs/prefer-immediate-return

  var builtLocale = {
    distanceInWords: {
      localize: localize
    }
  };
  return builtLocale;
};
var _default = buildLocale;
exports.default = _default;